// player-runtime-config.ts
export class PlayerRuntimeConfig {
	public static workerBaseUrl = '';
}
